module.exports = ngAnimate;